import { ComponentPropsWithoutRef } from 'react';

export const BorderedEqualizerIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none">
      <path
        d="M10 10V4m-5 8V4m10 10V4M3.4 1h13.2A2.4 2.4 0 0 1 19 3.4v13.2a2.4 2.4 0 0 1-2.4 2.4H3.4A2.4 2.4 0 0 1 1 16.6V3.4A2.4 2.4 0 0 1 3.4 1Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
